import { CheckmarkSquareOutline } from '@lyearn/icons';
import { DatabaseFieldTypeEnum } from '@/types/schema';

export const CheckboxFieldStaticConfig = {
  Icon: CheckmarkSquareOutline,
  type: DatabaseFieldTypeEnum.Checkbox,
  labelKey: 'Database:DataTypes.Checkbox',
};
